<script>
import SimpleCheckbox from "../Checkboxes/SimpleCheckbox.svelte";

export let checked = false;
export let name_input = "provider_id";
</script>

<SimpleCheckbox has_circle={false} is_column={true} classes="" classes_content="">
    <input type="radio" 
        on:change 
        checked={checked} 
        class="formElements" 
        name="{name_input}" 
        value="stripe" >
    <svelte-fragment slot="content">
        <figure class="is-flex is-justify-content-space-between is-align-items-center">
            <div class="container_img is-grid is-align-items-center">
                <img style="max-width:50px;" src="https://public-bucket.3pod.io/adm/gallery/imagen2026-02-17110053641-iozm.webp" alt="">
            </div>
            <figcaption class="has-text-grey fw400 is-flex is-align-items-center is-gap-5">
                <span>
                    <img style="max-width:40px;" src="https://bucket.3pod.io/adm/gallery/visa-8yas.webp" alt="">
                </span>
                <span>
                    <img style="max-width:40px;" src="https://bucket.3pod.io/adm/gallery/mastercard-uetl.webp" alt="">
                </span>
                <span>
                    <img style="max-width:40px;" src="https://bucket.3pod.io/adm/gallery/amex-78pw.webp" alt="">
                </span>
                <span>
                    <img style="max-width:40px;" src="https://bucket.3pod.io/adm/gallery/dinersclub-8g7b.webp" alt="">
                </span>
            </figcaption>
        </figure>
    </svelte-fragment>
</SimpleCheckbox>
